// models
import UserModel from '@/models/General/GUser'
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import ProductModel from '@/models/Warehouse/WhProduct'

// definitions
import DispatchRequestDetailHeaders from '@/views/Warehouse/WhDispatchRequest/receive/headers'
import ProductFilters from '@/views/Warehouse/WhProduct/list/filters'
import ProductHeaders from '@/views/Warehouse/WhProduct/list/headers'

// rules
import { date, required } from '@/services/validations'

//
export default ({ g_branch_office_id, readonly }) => [
    {
        name: 'sl_customer_rut',
        type: 'rut-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            rules: [required],
            textFieldProps: {
                readonly: true,
            },
            label: 'Rut',
            readonly: true,
        },
    },
    {
        name: 'sl_customer_alias_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            readonly: true,
            rules: [required],
            label: 'Alias',
        },
    },
    {
        name: 'sl_customer_branch_offices_address',
        type: 'text-field',
        flex: {
            sm6: true,
        },
        props: {
            readonly: true,
            rules: [required],
            label: 'Dirección',
        },
    },
    {
        name: 'g_seller_user_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Vendedor',
            model: UserModel,
            noDataText: 'Sin empleados.',
            noObject: true,
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'pch_payment_condition_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'type',
            itemValue: 'id',
            label: 'Condición de pago',
            model: PaymentConditionModel,
            multiple: true,
            noDataText: 'Sin tipos de pago.',
            noObject: true,
            paramSearch: 'type',
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'created_at',
        type: 'date-field',
        props: {
            fieldProps: {
                rules: [date, required],
            },
            label: 'Creado',
            pickerProps: {
                readonly: true,
            },
        },
    },
    {
        name: 'g_state_name',
        type: 'text-field',
        props: {
            label: 'Estado',
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'wh_selected_dispatch_requests',
        type: 'table-field',
        flex: {
            'd-grid': true,
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: DispatchRequestDetailHeaders,
            noActions: true,
            noDataText: 'Sin productos.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            showNativePagination: true,
            toolbarTitle: 'Lista de productos incluidos en la solicitud',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
            readonly,
            rules: [required],
        },
    },
    {
        name: 'reception_comment',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            label: 'Comentario de recepción',
        },
    },
]
